import { render } from "./SimpleLayout.vue?vue&type=template&id=0055e929&scoped=true"
const script = {}

import "./SimpleLayout.vue?vue&type=style&index=0&id=0055e929&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0055e929"]])

export default __exports__